import React from "react"
import BasePage from "../../components/layout/BasePage"
import { useQuery } from "@tanstack/react-query"
import { getDatenschutz } from "./api/apiCalls"
import Loading from "../../components/common/Loading"
import BaseSection from "../../components/layout/BaseSection"
import ReactMarkdown from "react-markdown"

export default function Datenschutz() {
    const { data, isLoading } = useQuery({
        queryKey: ["datenschutz"],
        queryFn: () => getDatenschutz(),
    })

    if (isLoading) {
        return <Loading />
    }

    return (
        <BasePage>
            <BaseSection flexCol  classProps="px-4 xl:px-0">
                <ReactMarkdown>{data.content}</ReactMarkdown>
            </BaseSection>
        </BasePage>
    )
}
